__turbopack_context__.v({
  "arrow": "index-module__0JILEa__arrow",
  "content": "index-module__0JILEa__content",
  "default": "index-module__0JILEa__default",
  "error": "index-module__0JILEa__error",
  "warning": "index-module__0JILEa__warning",
});
